<template>
  <div class="firstLoading">
    <!-- <div class="loading-block">
      <div v-if="loading">加载数据中...</div>
    </div> -->
  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      loading:true,
      EnterPaylod:{
        appId:"",
        nonceStr:"",//随机数
        sign:"",//签名秘钥
        taskNo:"",
          // appId: "1370986503395610626",
          // nonceStr: "153990756158595",
          // sign: "2ED588C6CE9908A9D0F33E58BEE7C1A7",
          // taskNo: "40161112890007805766"
      }
    }
  },
  mounted() {
    this.$toast.loading('数据加载中...')
    const url = new URL(location.href);
    this.EnterPaylod.appId = url.searchParams.get('appId');
    this.EnterPaylod.nonceStr= url.searchParams.get('nonceStr');
    this.EnterPaylod.sign= url.searchParams.get('sign');
    this.EnterPaylod.taskNo= url.searchParams.get('taskNo');
    this.postUserMessage()
  },
  methods:{
    postUserMessage(){
      this.$toast.clear()
      http.post(config.scanOrder,this.EnterPaylod).then(({code,data,message})=>{
        if(code===0){
          this.loading=false;
          if(data.code===200){
            this.$router.push({path:"/noLogin",})
            sessionStorage.setItem('taskNo', this.EnterPaylod.taskNo)
          }
        }else{
          this.loading=false;
          this.$toast.fail(message)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  width: 100%;
  height: 100%;
}
.loading-block{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/entryFile/taskLoading/index.vue